function throttle (callback, limit)
{
    var wait = false
    
    return function ()
    {
        if (!wait)
        {
            callback.apply(null, arguments)
            wait = true
            setTimeout(function ()
            {
                wait = false
            }, limit)
        }
    }
}

function debounce (func, wait, immediate)
{
	var timeout
    
    return function ()
    {
		var context = this, args = arguments
        var later = function ()
        {
			timeout = null
			if (!immediate) func.apply(context, args)
		}
		var callNow = immediate && !timeout
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
		if (callNow) func.apply(context, args)
	}
}

function setDelayedInterval (action, interval, delay, clearAfter)
{
    if (!delay) delay = 0
    if (!clearAfter) clearAfter = -1

    let actionInterval
    setTimeout(() => actionInterval = setInterval(action, interval), delay)

    if (clearAfter > 0)
    {
        setTimeout(() => clearInterval(actionInterval), clearAfter)
    }
}

export default { throttle, debounce, setDelayedInterval }


// WEBPACK FOOTER //
// ./src/utils/eventsUtils.js